import { WebApiActionGet, WebApiActionPut, QueryParams, WebApiItems } from "components/ajax/WebApi";
import { UserAccess } from "../../../utils/PermissionsUtils";

import rootUrl from "./url";

const baseUrl = rootUrl + "detail-clena/";


export interface Divize {
    Id: number;
    Nazev: string;
}

export interface Klub {
    Id: number;
    Nazev: string;
    NazevDivize: string;
    CisDivize: number;
    CisKlubu: number;
    DatVstupu: Date;
}


export interface Adresa {
    ulice: string;
    obec: string;
    psc: string;
    posta: string;
}

export interface ZakladniUdaje {
    Id: number;
    IdtClena: number;
    Prijmeni: string;
    Jmeno: string;
    Titul: string;
    DatNaroz: Date;
    RodCislo: string;
    Bydliste: Adresa;
    Telefony?: string;
    Emaily?: string;
    VekKtg: string;
    VekKtg2: string;
    Divize?: Divize;
    Klub?: Klub;
    Vymazan: boolean;
    Verified: boolean;
}


export interface ZakladniUdajeEdit {
    Overeny: boolean;
}

export interface SoutezniUdaje {
    VystupujeZa: string;
    Souticence: boolean;
    ProfiSoutLicence: boolean;
    PozastavenaSouticence: boolean;
    ZakazStartu: boolean;
    PlatneZdravProhlidky?: ZdravZpus[];

    VykDataStt?: VykData;
    VykDataLat?: VykData;
    VykDataSttSe?: VykData;
    VykDataLatSe?: VykData;

    NejTridaStt?: string;
    NejTridaLat?: string;
    NejTridaSttSe?: string;
    NejTridaLatSe?: string;

    ParStt?: Par;
    ParLat?: Par;
}

export interface ZdravZpus {
    TypId: number;
    Datum: Date;
    DoData?: Date;
    Nazev: string;
}

export interface Par {
    ParId: number;
    PartnerJmeno: string;
    PartnerPrijmeni: string;
    PartnerIdt: number;
    VekKtg: string;
    VystupujiZa: VystupujiZa;
    VykData: VykData;
    VykDataSe: VykData;
    SeniorskyPar: boolean;
}

export interface VystupujiZa {
    PartnerVystZa: string;
    PartnerKlubId?: number;
    PartnerHostovani: boolean;
    PartnerkaVystZa: string;
    PartnerkaKlubId?: number;
    PartnerkaHostovani: Boolean;
}

export interface VykData {
    Trida: string;
    Body: number;
    FinTuz: number;
    FinZahr: number;
}


export interface VyslSoutClena {
    Id: number;
    Datum: Date;
    Nazev: string;
    Misto: string;
    Kategorie: string;
    PoradiOd: number;
    PoradiDo: number;
    PartnerIdt?: number;
}

export interface EvopLicence {
    Nazev: string;
    DoData: Date;
    Platna: boolean;
}

export interface EvopLektorObor {
    Nazev: string;
}

export interface Licence {
    Funkce: EvopLicence[];
    LektorskeObory: EvopLektorObor[];
}


export const GetZakladniUdaje = function (clenId: number): WebApiActionGet<ZakladniUdaje> {
    return new WebApiActionGet<ZakladniUdaje>(baseUrl + `zakladni-udaje/${clenId}`);
}


export const GetSoutezniUdaje = function (clenId: number): WebApiActionGet<SoutezniUdaje> {
    return new WebApiActionGet<SoutezniUdaje>(baseUrl + `soutezni-udaje/${clenId}`);
}


export const GetVysledkySoutezi = function (idtClena: number): WebApiActionGet<WebApiItems<VyslSoutClena>> {
    return new WebApiActionGet<WebApiItems<VyslSoutClena>>(baseUrl + `vysledky-soutezi/${idtClena}`);
}

export const GetLicenceOp = function (clenId: number): WebApiActionGet<WebApiItems<Licence>> {
    return new WebApiActionGet<WebApiItems<Licence>>(baseUrl + `licence-op/${clenId}`);
}

export const apiUpdateZakladniUdaje = function (clenId: number): WebApiActionPut<ZakladniUdajeEdit, ZakladniUdaje> {
    return new WebApiActionPut<ZakladniUdajeEdit, ZakladniUdaje>(baseUrl + `zakladni-udaje/${clenId}`);
}

